import { InlineLink, Txt } from '@vst/beam';

import styles from './index.module.scss';

const SecondaryAction = ({
  description,
  link,
  href = '#',
  onClick,
}: {
  description: string;
  link: string;
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}) => (
  <div className={styles['secondary-action']}>
    <Txt variant="bodySmallRegular">
      <span>{description}</span>
      <InlineLink href={href} onClick={onClick}>
        {link}
      </InlineLink>
    </Txt>
  </div>
);

export default SecondaryAction;
